<mat-card>
  <app-card-header [title]="data.blockContent.title" [icon]="data.icon">
    <ng-container *ngIf="!data.isNotRegisteredCourses">
      <!-- <app-print-button class="d-phone-none" [tooltipText]="data.blockContent.printTooltipText" (printClick)="printBtnClick()" /> TODO -->
      <!--<app-share-button *ngIf="!isServerError" (addToCalendarClick)="addToCalendarClick($event)" />-->
    </ng-container>
  </app-card-header>

  <mat-card-content *ngIf="!isServerError">
    <ng-container *ngIf="!data.isNotRegisteredCourses">
      <app-schedule [data]="data" (serverErrorAppeared)="serverErrorAppeared()" />

      <app-alert *ngIf="data.comments" class="mt-2" [icon]="'alert'">
        <span [innerHTML]="data.comments"></span>
      </app-alert>
    </ng-container>

    <app-schedule-not-registered *ngIf="data.isNotRegisteredCourses" [title]="data.blockContent.notRegisteredCoursesTitle" [message]="data.notRegisteredCoursesMessage" 
      [linksList]="data.blockContent.notRegisteredCoursesLinks" [linksTitle]="data.blockContent.notRegisteredCoursesLinkTitle" [image]="data.notRegisteredCoursesImage"/>
  </mat-card-content>

  <mat-card-content *ngIf="isServerError">
    <app-timeout-error-message></app-timeout-error-message>
  </mat-card-content>
</mat-card>